const ITEMS = [
    "99.99% ETP Copper",
    "IS 694 · IS 1554 Certified",
    "XLPE Insulated",
    "Flame Retardant LSZH",
    "Armoured SWA / AWA",
    "EN 50618 Solar PV",
    "Test Certificates Available On Request",
    "Dispatch Confirmed Per Quote",
];

function Row({ hidden = false }) {
    return (
        <div aria-hidden={hidden} className="flex shrink-0 items-center">
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center shrink-0">
                    <span className="font-display font-semibold text-xl md:text-2xl text-white/85 whitespace-nowrap px-6 italic">
                        {item}
                    </span>
                    <span className="w-2 h-2 rotate-45 bg-copper-bright shrink-0" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="relative bg-inkdark py-5 overflow-hidden marquee-mask" data-testid="marquee-band">
            <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
